"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedkey = void 0;
function typedkey(value, convertor) {
    return convertor !== undefined && convertor !== null
        ? Object.keys(value).map((key) => convertor(key))
        : Object.keys(value);
}
exports.typedkey = typedkey;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWlzYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9taXNjLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLFFBQVEsQ0FDdEIsS0FBUSxFQUNSLFNBQWtDO0lBRWxDLE9BQU8sU0FBUyxLQUFLLFNBQVMsSUFBSSxTQUFTLEtBQUssSUFBSTtRQUNsRCxDQUFDLENBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQVMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxHQUFRLEVBQUUsRUFBRSxDQUFDLFNBQVMsQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUMvRCxDQUFDLENBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQVMsQ0FBQztBQUNsQyxDQUFDO0FBUEQsNEJBT0MifQ==